/* eslint-disable react-hooks/exhaustive-deps */
// import queryString from "query-string"
import { useEffect, useRef, useState } from "react"
import { Button, Card, Col, Container, Row } from "react-bootstrap"
import { useDispatch, useSelector } from "react-redux"
import { Prompt, useHistory, useParams } from "react-router-dom"
import { AppDispatch } from "../../.."
import AlertComponent from "../../../components/AlertComponent"
import ComboBox from "../../../components/ComboBox"
import { T部所マスタ } from "../../../components/ComboBox/BusyoComboBox"
import { showInfoToast } from "../../../components/CustomToast"
import TextInput from "../../../components/InputWrapper/TextInput"
import TextAreaInput from "../../../components/InputWrapper/TextAreaInput"
import DateInput from "../../../components/InputWrapper/DateInput"
import MasterRegisterFormRow from "../../../components/MasterRegisterFormRow"
import ConfirmModal from "../../../components/Modal/ConfirmModal"
import CONSTANT from "../../../constant"
import {
  clearAlert,
  setAlerts,
  setWarningAlerts,
} from "../../../globalStore/alertStore"
import {
  画面ロック解除,
  画面ロック開始,
} from "../../../globalStore/progressStore"
import { TApiResponse } from "../../../service/TApiResponse"
import util from "../../../ts/util"
import { TWijmoComboBox } from "../../../type/wijmoComponents"
import BusyoService from "../../../service/master/busyo/busyoService"
import KubunService from "../../../service/master/kubun/kubunService"
import Ajv, { ErrorObject } from "ajv"
import ajvErrors from "ajv-errors"
import {
  TOsiraseRegisterPostReqSchema,
  TOsiraseUpdatePutReqSchema,
} from "../../../service/master/osirase/osiraseSchema"
import { RootState } from "../../../globalStore/rootreducer"
import { メニューコード } from "../../../constant/menuCode"
import CheckInput from "../../../components/InputWrapper/CheckInput"
import OsiraseService from "../../../service/master/osirase/osiraseService"
import {
  TOsiraseRegisterPostReq,
  TOsiraseUpdatePutReq,
} from "../../../service/master/osirase/TOsirase"
import { T区分マスタ } from "../../../components/ComboBox/KubunComboBox"
import { 区分分類コード } from "../../../constant/enum/codes"

/**
 *　お知らせ登録
 * @returns
 */
const OsiraseRegister = () => {
  const history = useHistory()
  // const { id } = useParams<{ id: string }>()
  const { id: paramId } = useParams<{ id: string }>()
  const id = paramId ? parseInt(paramId) : undefined
  const disPatch: AppDispatch = useDispatch()

  const 読取専用フラグ = useSelector(
    (rootState: RootState) =>
      rootState.menu.menuPage.find(
        (m) => m.メニューコード === メニューコード.マスタ管理.お知らせ登録
      )?.読み取り専用フラグ
  )

  // 戻る確認ダイアログ表示フラグ
  const isPrompt = useRef(false)
  const [isConfirmModalShow, setIsConfirmModalShow] = useState(false)
  const [isConfirmDeleteModalShow, setIsConfirmDeleteModalShow] =
    useState(false)

  //#region [state]

  // 表示項目のstate
  const [掲載開始日, set掲載開始日] = useState<string | null>()
  const [掲載終了日, set掲載終了日] = useState<string | null>()
  const [タイトル, setタイトル] = useState<string>("")
  const [お知らせ分類区分コード, setお知らせ分類区分コード] = useState<
    string | null
  >()
  const [区分ItemSource, set区分ItemSource] = useState<T区分マスタ[]>()
  const [部所コード, set部所コード] = useState<string | null>("")
  const [強調表示フラグ, set強調表示フラグ] = useState<0 | 1>()
  const [内容, set内容] = useState<string>("")
  const [備考, set備考] = useState<string>("")
  const [更新日時, set更新日時] = useState<string>("")
  const [最終更新ID, set最終更新ID] = useState<string>()

  // エラー表示用フラグ
  const [isInvalid掲載開始日, setIsInvalid掲載開始日] = useState<boolean>(false)
  const [isInvalid掲載終了日, setIsInvalid掲載終了日] = useState<boolean>(false)
  const [isInvalidタイトル, setIsInvalidタイトル] = useState<boolean>(false)
  const [isInvalidお知らせ分類区分コード, setIsInvalidお知らせ分類区分コード] =
    useState<boolean>(false)
  const [isInvalid部所コード, setIsInvalid部所コード] = useState<boolean>(false)
  const [, setIsInvalid強調表示フラグ] = useState<boolean>(false)
  const [isInvalid内容, setIsInvalid内容] = useState<boolean>(false)
  const [isInvalid備考, setIsInvalid備考] = useState<boolean>(false)
  const [, setIsInvalid更新日時] = useState<boolean>(false)

  //アラート制御
  const dispatch: AppDispatch = useDispatch()

  //#endregion

  //#region [comboboxState]

  // お知らせ分類区分
  const [お知らせ分類区分ComboBox, setお知らせ分類区分ComboBox] =
    useState<TWijmoComboBox<T区分マスタ["区分コード"], T区分マスタ> | null>(
      null
    )
  const [お知らせ分類区分IsLoadEnded, setお知らせ分類区分IsLoadEnded] =
    useState<boolean>(false)

  // 部所
  const [部所ComboBox, set部所ComboBox] = useState<TWijmoComboBox<
    string,
    T部所マスタ
  > | null>(null)
  const [部所IsLoadEnded, set部所IsLoadEnded] = useState<boolean>(false)
  const [部所ItemSource, set部所ItemSource] = useState<T部所マスタ[]>()

  //#endregion

  //#region [method]

  /**
   * データ取得
   */
  const getData = async (id: number) => {
    dispatch(clearAlert()) // アラートを非表示に
    const service = new OsiraseService()

    try {
      const res = await service.get(id)

      if (res.data) {
        set掲載開始日(res.data.掲載開始日)
        set掲載終了日(res.data.掲載終了日)
        setタイトル(res.data.タイトル)
        setお知らせ分類区分コード(res.data.お知らせ分類区分コード)
        set部所コード(res.data.部所コード)
        set強調表示フラグ(res.data.強調表示フラグ)
        set内容(res.data.内容)
        set備考(res.data.備考)
        set更新日時(res.data.更新日時)
        set最終更新ID(
          res.data.更新ユーザID ? res.data.更新ユーザID.toString() : ""
        )
      }
    } catch (error) {
      disPatch(setAlerts(error))
    } finally {
    }
  }

  /**
   * 登録アイテム生成
   */
  const getPostReq = (): TOsiraseRegisterPostReq => {
    return {
      掲載開始日: 掲載開始日 ?? "",
      掲載終了日: 掲載終了日 ?? "",
      タイトル,
      お知らせ分類区分コード: お知らせ分類区分コード ?? "",
      部所コード: 部所コード ?? "",
      強調表示フラグ: 強調表示フラグ ? 1 : 0,
      内容,
      備考,
    }
  }

  /**
   * 更新アイテム生成
   */
  const getPutReq = (): TOsiraseUpdatePutReq => {
    return {
      掲載開始日: 掲載開始日 ?? "",
      掲載終了日: 掲載終了日 ?? "",
      タイトル,
      お知らせ分類区分コード: お知らせ分類区分コード ?? "",
      部所コード: 部所コード ?? "",
      強調表示フラグ: 強調表示フラグ ? 1 : 0,
      内容,
      備考,
      更新日時,
    }
  }

  /**
   * 送信前バリデーションチェックなど
   */
  const beforeSubmit = () => {
    const ajv = new Ajv({ allErrors: true })
    ajvErrors(ajv)
    let schema
    let data
    if (id) {
      schema = TOsiraseUpdatePutReqSchema
      data = getPutReq()
    } else {
      schema = TOsiraseRegisterPostReqSchema
      data = getPostReq()
    }
    const validate = ajv.compile(schema)
    const validateResult = validate(data)
    if (!validateResult) {
      const errors = validate.errors
      const errorMessages: string[] = []
      if (errors != null && errors.length > 0) {
        //エラーメッセージのparamsより対象の項目を発見し色変え
        setValidateError(errors)
        errorMessages.push(
          ...errors.filter((e) => e.message != null).map((e) => e.message ?? "")
        )
      }
      disPatch(setWarningAlerts([...errorMessages]))
      return
    }

    setIsConfirmModalShow(true)
  }

  /**
   * 削除送信前
   */
  const beforeDeleteSubmit = () => {
    setIsConfirmDeleteModalShow(true)
  }

  /**
   * エラー発生時の項目色変え
   * @param errors
   */
  const setValidateError = (
    errors: ErrorObject<string, Record<string, any>, unknown>[]
  ) => {
    const instancePaths = errors.map((e) => e.instancePath.replaceAll("/", ""))
    const requiredProperties = errors
      .filter(
        (e) =>
          e.instancePath === "" &&
          e.params.errors != null &&
          e.params.errors.length > 0 &&
          e.params.errors.find(
            (ec: { keyword: string }) => ec.keyword === "required"
          )
      )
      .map((e) => {
        const error = e.params.errors[0]
        return error.params.missingProperty
      })
    const errorProperties = [...instancePaths, ...requiredProperties]

    setIsInvalid掲載開始日(errorProperties.includes("掲載開始日"))
    setIsInvalid掲載終了日(errorProperties.includes("掲載終了日"))
    setIsInvalidタイトル(errorProperties.includes("タイトル"))
    setIsInvalidお知らせ分類区分コード(
      errorProperties.includes("お知らせ分類区分コード")
    )
    setIsInvalid部所コード(errorProperties.includes("部所コード"))
    setIsInvalid強調表示フラグ(errorProperties.includes("強調表示フラグ"))
    setIsInvalid内容(errorProperties.includes("内容"))
    setIsInvalid備考(errorProperties.includes("備考"))
    setIsInvalid更新日時(errorProperties.includes("更新日時"))
  }

  /**
   * 送信
   */
  const submit = async () => {
    try {
      const service = new OsiraseService()
      let res: TApiResponse<boolean>

      if (id) {
        // 更新
        res = await service.put(id, getPutReq())
      } else {
        // 登録
        res = await service.post(getPostReq())
      }

      if (res) {
        isPrompt.current = false
        history.goBack()
        showInfoToast(`お知らせの${id ? "更新" : "登録"}が完了しました`)
      }
    } catch (error) {
      disPatch(setAlerts(error))
    } finally {
      setIsConfirmModalShow(false)
    }
  }

  /**
   * 削除
   */
  const doDelete = async () => {
    try {
      const service = new OsiraseService()
      const res: TApiResponse<boolean> = await service.delete(id!, {
        更新日時: 更新日時!,
      })
      disPatch(setAlerts(res))
      if (res) {
        isPrompt.current = false
        history.goBack()
        showInfoToast(`お知らせを削除しました`)
      }
    } catch (error) {
      disPatch(setAlerts(error))
    } finally {
      setIsConfirmDeleteModalShow(false)
    }
  }

  //#endregion

  //#region [effect]

  //初期設定
  useEffect(() => {
    //画面全体ロック
    disPatch(画面ロック開始())

    Promise.all([
      new BusyoService().getList({}),
      new KubunService().getList(),
    ]).then(([部所ListRes, 区分マスタRes]) => {
      set部所ItemSource(部所ListRes.data)
      set区分ItemSource(区分マスタRes.data)
      // id存在時はデータを取得し更新
      if (id) {
        getData(id).finally(() => {
          disPatch(画面ロック解除())
        })
        // ファイルロード後、戻るボタン押下時に警告が出るように変更
        isPrompt.current = !読取専用フラグ
      } else {
        disPatch(画面ロック解除())
        // ファイルロード後、戻るボタン押下時に警告が出るように変更
        isPrompt.current = !読取専用フラグ
      }
    })
  }, [])

  //#endregion

  return (
    <>
      <Prompt
        when={isPrompt.current}
        message={CONSTANT.MESSAGES.BROWSER_BACK}></Prompt>
      <Container fluid>
        {/* 画面タイトル */}
        <Row className="page-title-row">
          <Col className="page-title-col">
            <span className="page-title">お知らせ{id ? `更新` : `登録`}</span>
          </Col>
        </Row>
        {/* アラート表示 */}
        <Row>
          <Col>
            <AlertComponent />
          </Col>
        </Row>
        <Row>
          <Col>
            <Card className="w-85rem">
              <Card.Body>
                <Container fluid className="register-form">
                  {/* 掲載期間 */}
                  <MasterRegisterFormRow label="掲載期間" isRequired={true}>
                    <div className="w-10rem">
                      <DateInput
                        id="掲載開始日"
                        value={掲載開始日}
                        isRequired={false}
                        defaultValue={null}
                        setValue={set掲載開始日}
                        className={isInvalid掲載開始日 ? "is-error" : ""}
                        autoFocus={true}
                      />
                    </div>
                    <div className="form-label-right">から</div>
                    <div className="w-10rem">
                      <DateInput
                        id="掲載終了日"
                        value={掲載終了日}
                        isRequired={false}
                        defaultValue={null}
                        setValue={set掲載終了日}
                        className={isInvalid掲載終了日 ? "is-error" : ""}
                      />
                    </div>
                    <div className="form-label-right">まで</div>
                  </MasterRegisterFormRow>
                  {/* タイトル */}
                  <MasterRegisterFormRow label="タイトル" isRequired={true}>
                    <TextInput
                      style={{ width: "50rem" }}
                      id="タイトル"
                      name="タイトル"
                      value={タイトル}
                      setValue={setタイトル}
                      maxLength={100}
                      className={isInvalidタイトル ? "is-error" : ""}
                    />
                  </MasterRegisterFormRow>
                  {/* お知らせ分類区分 */}
                  <MasterRegisterFormRow label="カテゴリ" isRequired={false}>
                    <ComboBox.Kubun
                      分類コード={区分分類コード.マスタ.お知らせ分類区分}
                      isLoadEnded={お知らせ分類区分IsLoadEnded}
                      setIsLoadEnded={setお知らせ分類区分IsLoadEnded}
                      isAllSelect={false}
                      isRequired={false}
                      isEmpty={true}
                      itemsSource={区分ItemSource}
                      selectedValue={お知らせ分類区分コード}
                      setSelectedValue={setお知らせ分類区分コード}
                      ComboBox={お知らせ分類区分ComboBox}
                      setComboBox={setお知らせ分類区分ComboBox}
                      className={
                        isInvalidお知らせ分類区分コード ? "is-error" : ""
                      }></ComboBox.Kubun>
                  </MasterRegisterFormRow>
                  {/* 部所 */}
                  <MasterRegisterFormRow label="対象部所" isRequired={false}>
                    <ComboBox.Busyo
                      itemsSource={部所ItemSource}
                      isLoadEnded={部所IsLoadEnded}
                      setIsLoadEnded={set部所IsLoadEnded}
                      isEmpty={true}
                      selectedValue={部所コード}
                      setSelectedValue={set部所コード}
                      ComboBox={部所ComboBox}
                      setComboBox={set部所ComboBox}
                      className={
                        isInvalid部所コード ? "is-error" : ""
                      }></ComboBox.Busyo>
                  </MasterRegisterFormRow>
                  {/* 強調表示フラグ */}
                  <MasterRegisterFormRow
                    label="強調表示フラグ"
                    isRequired={false}>
                    <CheckInput
                      id="強調表示フラグ"
                      type={"switch"}
                      label={""}
                      setValue={(v) => {
                        v === 1 ? set強調表示フラグ(v) : set強調表示フラグ(0)
                      }}
                      value={強調表示フラグ ?? 0}
                    />
                  </MasterRegisterFormRow>
                  {/* 内容 */}
                  <MasterRegisterFormRow label="内容" isRequired={false}>
                    <TextAreaInput
                      style={{ width: "50rem", height: "30rem" }}
                      value={内容}
                      setValue={set内容}
                      className={[isInvalid内容 && "is-error"].join(
                        " "
                      )}></TextAreaInput>
                  </MasterRegisterFormRow>
                  {/* 備考 */}
                  <MasterRegisterFormRow label="備考" isRequired={false}>
                    <TextAreaInput
                      style={{ width: "50rem" }}
                      value={備考}
                      setValue={set備考}
                      className={[isInvalid備考 && "is-error"].join(
                        " "
                      )}></TextAreaInput>
                  </MasterRegisterFormRow>
                </Container>
              </Card.Body>
            </Card>
          </Col>
        </Row>
        {id && (
          <>
            <Row>
              <Col>
                更新日時: {util.date.format(更新日時, "YYYY/MM/DD HH:mm:ss")}
              </Col>
            </Row>
            <Row>
              <Col>最終更新ID : {最終更新ID}</Col>
            </Row>
          </>
        )}
        <Row className="search-button">
          <Col>
            {!読取専用フラグ && (
              <Button
                type="submit"
                variant="waiting"
                onClick={(e) => {
                  e.stopPropagation()
                  e.preventDefault()
                  beforeSubmit()
                }}>
                {id ? `更新` : `登録`}
              </Button>
            )}
            <Button
              className="ms-3"
              type="button"
              variant="secondary"
              onClick={() => history.goBack()}>
              一覧に戻る
            </Button>
            {!読取専用フラグ && (
              <Button
                size="lg"
                className="ms-5"
                variant="caution"
                disabled={!id}
                onClick={(e) => {
                  e.stopPropagation()
                  e.preventDefault()
                  beforeDeleteSubmit()
                }}>
                削除
              </Button>
            )}
          </Col>
        </Row>
      </Container>
      <ConfirmModal
        isShow={isConfirmModalShow}
        hideHandler={setIsConfirmModalShow}
        submitHandler={submit}>
        入力された内容で{id ? "更新" : "登録"}しますか？
      </ConfirmModal>
      <ConfirmModal
        isShow={isConfirmDeleteModalShow}
        hideHandler={setIsConfirmDeleteModalShow}
        submitHandler={doDelete}>
        お知らせを削除しますか？
      </ConfirmModal>
    </>
  )
}

export default OsiraseRegister
